import type { InsertScimTokenMutation } from '@risksmart-app/web-graphql-client/generated/graphql';
import { useMutation, useQueryClient } from '@tanstack/react-query';

import { useTRPC } from '@/utils/trpc';

type InsertScimTokenInput = { expireInMonths: '6' | '12' | '24' };

const mapTrpcResponseToGraphQL = (trpcData: {
  keyId: string;
  orgKey: string;
  createdOn: string;
  expiresOn: string;
  status: 'active' | 'expired' | 'revoked';
  token: string;
}): InsertScimTokenMutation => ({
  insert_scim_token: {
    __typename: 'ScimTokenOutput',
    keyId: trpcData.keyId,
    orgKey: trpcData.orgKey,
    token: trpcData.token,
    createdOn: trpcData.createdOn,
    expiresOn: trpcData.expiresOn,
    status: trpcData.status,
  },
});

export const useInsertScimTokenTRPC = () => {
  const trpc = useTRPC();
  const queryClient = useQueryClient();
  const mutation = useMutation({
    ...trpc.frontend.scim.issueToken.mutationOptions({
      onSuccess: async () => {
        await queryClient.invalidateQueries({
          queryKey: trpc.frontend.scim.getConfig.queryKey(),
        });
      },
    }),
  });

  return {
    insertScimToken: async (
      variables: InsertScimTokenInput
    ): Promise<InsertScimTokenMutation> => {
      const result = await mutation.mutateAsync(variables);

      return mapTrpcResponseToGraphQL(result);
    },
    loading: mutation.isPending,
    error: mutation.error,
  };
};
